(function ($) {

  const pageHeader = document.querySelector(".megamenu");
  const toggleMenu = pageHeader.querySelector(".toggle-menu");
  const menuWrapper = pageHeader.querySelector(".menu-wrapper");
  const level1Links = pageHeader.querySelectorAll(".level-1 > li > a");
  const listWrapper2 = pageHeader.querySelector(".list-wrapper:nth-child(2)");
  const listWrapper3 = pageHeader.querySelector(".list-wrapper:nth-child(3)");
  const subMenuWrapper2 = listWrapper2.querySelector(".sub-menu-wrapper");
  const subMenuWrapper3 = listWrapper3.querySelector(".sub-menu-wrapper");
  const backOneLevelBtns = pageHeader.querySelectorAll(".back-one-level");
  const back2 = listWrapper2.querySelector(".back-one-level ");
  const back3 = listWrapper3.querySelector(".back-one-level ");
  const backLabel2 = listWrapper2.querySelector(".back-one-level span");
  const backLabel3 = listWrapper3.querySelector(".back-one-level span");
  const isVisibleClass = "is-visible";
  const isActiveClass = "is-active";
  const isCurrent = "is-current";
  const wasCurrent = "was-current";

  toggleMenu.addEventListener("click", function () {
    menuWrapper.classList.toggle(isVisibleClass);
    if (!this.classList.contains(isVisibleClass)) {
      listWrapper2.classList.remove(isVisibleClass);
      listWrapper3.classList.remove(isVisibleClass);
      const menuLinks = menuWrapper.querySelectorAll("a");
      for (const menuLink of menuLinks) {
        menuLink.classList.remove(isActiveClass);
      }
      backLabel2.textContent = "";
      backLabel3.textContent = "";
    }
  });

  for (const level1Link of level1Links) {
    const levelOneText = level1Link.textContent;
    level1Link.addEventListener("click", function (e) {
      const siblingList = level1Link.nextElementSibling;
      if (siblingList) {
        e.preventDefault();
        this.classList.add(isActiveClass);
        jQuery(this).closest('ul').addClass(isCurrent);
        jQuery(this).closest('ul').removeClass(wasCurrent);
        jQuery(this).closest('ul').parent().find(".single-item.first__level").addClass(isCurrent);
        jQuery(this).closest('ul').parent().find(".single-item.first__level").removeClass(wasCurrent);
        jQuery(this).closest('ul').parent().find(".media__heading__first-level").addClass(isCurrent);
        jQuery(this).closest('ul').parent().find(".media__heading__first-level").removeClass(wasCurrent);
        const cloneSiblingList = siblingList.cloneNode(true);
        subMenuWrapper2.innerHTML = "";
        subMenuWrapper2.append(cloneSiblingList);
        listWrapper2.classList.add(isVisibleClass);
        backLabel2.textContent = level1Link.textContent;
      }
    });
  }

  listWrapper2.addEventListener("click", function (e) {
    const target = e.target;
    if (target.tagName.toLowerCase() === "a" && target.nextElementSibling) {
      const siblingList = target.nextElementSibling;
      e.preventDefault();
      target.classList.add(isActiveClass);
      jQuery(target).closest('ul').addClass(isCurrent);
      jQuery(target).closest('ul').removeClass(wasCurrent);
      const ClosesButton = jQuery(target).closest("ul").parent().closest(".sub-menu-wrapper").parent().find(".back-one-level").text();
     // console.log(ClosesButton);
      jQuery(back2).addClass(isCurrent);
      jQuery(back2).removeClass(wasCurrent);
      const cloneSiblingList = siblingList.cloneNode(true);
      subMenuWrapper3.innerHTML = "";
      subMenuWrapper3.append(cloneSiblingList);
      listWrapper3.classList.add(isVisibleClass);
      const buttonThreeText = ClosesButton + "&nbsp; / &nbsp; " + target.textContent;
      backLabel3.innerHTML = buttonThreeText;
    }
  });

  for (const backOneLevelBtn of backOneLevelBtns) {

    back2.addEventListener("click", function () {
      const parent = this.closest(".list-wrapper");
      const image = jQuery(".single-item.first__level");
      parent.classList.remove(isVisibleClass);
      const current = jQuery(".level-1.is-current");
      current.addClass(wasCurrent);
      current.removeClass(isCurrent);
      jQuery(back2).removeClass(isCurrent);
      jQuery(back2).addClass(wasCurrent);
      jQuery(".sub-menu.level-2").removeClass(isCurrent);
      jQuery(".sub-menu.level-2").addClass(wasCurrent);
      jQuery(".single-item.first__level").addClass(wasCurrent);
      jQuery(".single-item.first__level").removeClass(isCurrent);
      jQuery(".media__heading__first-level").addClass(wasCurrent);
      jQuery(".media__heading__first-level").removeClass(isCurrent);
      parent.previousElementSibling
        .querySelector(".is-active")
        .classList.remove(isActiveClass);
    });

    back3.addEventListener("click", function () {
      const parent = this.closest(".list-wrapper");
      parent.classList.remove(isVisibleClass);
      const current = jQuery(".level-1.is-current");
      jQuery(back2).removeClass(isCurrent);
      jQuery(back2).addClass(wasCurrent);
      jQuery(".sub-menu.level-2").removeClass(isCurrent);
      jQuery(".sub-menu.level-2").addClass(wasCurrent);
      parent.previousElementSibling
        .querySelector(".is-active")
        .classList.remove(isActiveClass);
    });

  }

}());


// scroll function 

(function ($) {
  $(window).scroll(function () {

    if ($(document).scrollTop() >= 30) {

      $('.boost-pfs-search-suggestion-wrapper').addClass('search-scrolled');
      $('.boost-pfs-search-suggestion-wrapper').removeClass('search-not-scrolled');

    } else {

      $('.boost-pfs-search-suggestion-wrapper').removeClass('search-scrolled');
      $('.boost-pfs-search-suggestion-wrapper').addClass('search-not-scrolled');
      $("#stickyheader").css("overflow", "hidden!important");
      

    }


    if ($(".mobile-menu .menu-wrapper").hasClass("is-visible")) {
  

    } else {

      if ($(document).scrollTop() > 30) {


        $(".megamenu.homeonly").addClass("scrolled");
        $(".megamenu.homeonly").removeClass("notscrolled");
        $('.megamenu.homeonly a.logo').addClass('alternative');
        $('.megamenu.homeonly li.menu-item.level_1 > a').addClass('alternative');
        $('.megamenu.homeonly a.nav__icons.user').addClass("alternative");
        $('.megamenu.homeonly a.wishlist').addClass("alternative");
        $('.megamenu.homeonly a.nav__icons.cart').addClass("alternative");
        $('.megamenu.homeonly #searchicndw').addClass('d-none');


        $('.megamenu.homeonly #searchicndwd').addClass('d-none');
        $('.megamenu.homeonly #searchicndd').removeClass('d-none');
        $('.megamenu.homeonly #burgericnbw').addClass('d-none');
        $('.megamenu.homeonly #burgericn').removeClass('d-none');

        $('.megamenu.homeonly #cart-has-items').removeClass('alternative');
        $(".megamenu.homeonly").removeClass("wasscrolled");
        $("body").css("overflow", "hidden!important");
        $(".megamenu.homeonly").css("background", "white");


        if ($("#searchBar").css("display") == "block") {
          $('.megamenu.homeonly #searchicnd').addClass('d-none');
          $('.megamenu.homeonly #searchicnd').hide();
        } else {
          $('.megamenu.homeonly #searchicnd').removeClass('d-none');
          $('.megamenu.homeonly #searchicnd').show();
        }




      } else {

        if ($("#searchBar").css("display") == "block") {

          $('.megamenu.homeonly #burgericn').removeClass('d-none');
          $('.megamenu.homeonly #burgericn').show();
          // $('.megamenu.homeonly a.logo').addClass('alternative');
          //$('.boost-pfs-search-suggestion-mobile.boost-pfs-search-suggestion-wrapper').removeClass('search-scrolled');

        } else {

          
          //qui 
          if (document.documentElement.clientWidth < 1024) {


            if ($(".megamenu").hasClass("was-open")) {

             // console.log("scrolled more than 30 has class was-open");
              $(".megamenu.homeonly").css("background-color", "white");

            } else {

              $(".megamenu.homeonly").removeClass("scrolled");
              $(".megamenu.homeonly").addClass("notscrolled");
              //$(".megamenu.homeonly").addClass("wasscrolled");
              $('.megamenu.homeonly a.logo').removeClass('alternative');
              $('.megamenu.homeonly a.wishlist').removeClass("alternative");
              $('.megamenu.homeonly li.menu-item.level_1 > a').removeClass('alternative');
              $('.megamenu.homeonly a.nav__icons.user').removeClass("alternative");
              $('.megamenu.homeonly a.nav__icons.cart').removeClass("alternative");
              $('.megamenu.homeonly #searchicndw').removeClass('d-none');
              $('.megamenu.homeonly #searchicndw').show();
              $('.megamenu.homeonly #searchicnd').addClass('d-none');
              $('.megamenu.homeonly #searchicndwd').removeClass('d-none');
              $('.megamenu.homeonly #searchicndd').addClass('d-none');
              $('.megamenu.homeonly #burgericnbw').removeClass('d-none');
              $('.megamenu.homeonly #burgericn').addClass('d-none');

              $('.megamenu.homeonly #cart-has-items').addClass('alternative');

            }
          } else {

            $('.megamenu.homeonly a.logo').removeClass('alternative');
            $('.megamenu.homeonly li.menu-item.level_1 > a').removeClass('alternative');
            $('.megamenu.homeonly a.wishlist').removeClass("alternative");
            $('.megamenu.homeonly a.nav__icons.user').removeClass("alternative");
            $('.megamenu.homeonly a.nav__icons.cart').removeClass("alternative");
            $('.megamenu.homeonly #searchicndw').removeClass('d-none');
            $('.megamenu.homeonly #searchicndw').show();
            $('.megamenu.homeonly #searchicnd').addClass('d-none');
            $('.megamenu.homeonly #searchicndwd').removeClass('d-none');
            $('.megamenu.homeonly #searchicndd').addClass('d-none');
            $('.megamenu.homeonly #burgericnbw').removeClass('d-none');
            $('.megamenu.homeonly #burgericn').addClass('d-none');
            $('.megamenu.homeonly #cart-has-items').addClass('alternative');
            $(".megamenu.homeonly").css("background", "transparent");
    
            

          }



        }

        $(".megamenu.homeonly").css("background-color", "transparent");

        setTimeout(function () {
          $(".megamenu.homeonly").removeClass("notscrolled");
          //   $(".megamenu.homeonly").removeClass("was-open");
        }, 350);
      }
    }
  });


//scroll event
$(function(){
  var lastScrollTop = 0, delta = 5;
  $(window).scroll(function(){
    var nowScrollTop = $(this).scrollTop();
    if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
      if (nowScrollTop > lastScrollTop){
     
     //   console.log("scrollling down");

      } else {
        
      //  console.log("scrollling up");
        $('.megamenu.homeonly').removeClass('was-open');    
        $('.megamenu.homeonly').addClass('was-open-fade');  
     }
    lastScrollTop = nowScrollTop;
    }
  });
});


  $(".level_1").hover(function () {

    var submenu = $(this).find(".submenu");
    var allsubmenu = $(".submenu");
    var overlay = $(".megamenu__overlay");
    var visibility = $(submenu).css("display");
    if (submenu.length) {

      $(overlay).addClass("visible");

    } else {

      $(overlay).removeClass("visible");
    }
  }).mouseover(function () {
    if (jQuery(".submenu").is(":visible")) {

    } else {
      $(overlay).removeClass("visible");
    }

  });


  var overlay = $(".megamenu__overlay");


  $(".megamenu__overlay").on("mouseover mouseleave", function () {
    if ($(".submenu").css("display") == "flex") {
      // Element has display: flex
    } else {
      // Element has a different display value
      $(overlay).removeClass("visible");
    }

  });


  $('#GlobaleFreeShippingBannerContainer').hover(

    function () {
      $('.megamenu__overlay').removeClass("visible");
    },

    function () {

    }
  );

  $('.news_ticker_container').hover(

    function () {
      $('.megamenu__overlay').removeClass("visible");
    },

    function () {

    }
  );

  $(".megamenu.homeonly").mouseleave(function () {
    $('.megamenu__overlay').removeClass("visible");
  });


    $('.menu-item').hover(

    function () {
    
    },

    function () {
      $('.megamenu__overlay').removeClass("visible");
    }
  );




  //mousehover megamenu
  $('.megamenu.homeonly').hover(

    function () {
  
      if ($(document).scrollTop() < 30) {

        if (document.documentElement.clientWidth < 1024) {
          $('.megamenu.homeonly').css("background", "white");
  
        }
  
        else {
          $(".megamenu").css("background", "white");
        }
  
       
        $('a.logo').addClass("alternative");
        $('a.nav__icons.user').addClass("alternative");
        $('a.nav__icons.cart').addClass("alternative");
        $('a.wishlist').addClass("alternative");

        $('nav.megamenu.homeonly li.menu-item.level_1 > a').addClass('alternative');
  
        $('.megamenu.homeonly #burgericnbw').addClass('d-none');
        $('.megamenu.homeonly #burgericn').removeClass('d-none');
  
        //bug 
  
        $('.megamenu.homeonly #searchicnd').removeClass('d-none');
        $('.megamenu.homeonly #searchicndd').removeClass('d-none');
        //  $('.megamenu.homeonly #searchicnd').show();
        $('.megamenu.homeonly #searchicndw').addClass('d-none');
        $('.megamenu.homeonly #searchicndwd').addClass('d-none');
        $('.megamenu.homeonly #cart-has-items').removeClass('alternative');
  
        //mousehover megamenu
      }

    },

    function () {
 


      if ($(document).scrollTop() < 30) {

      
      if (document.documentElement.clientWidth > 1024) {
      
        $('.megamenu.homeonly a.logo').removeClass('alternative');
        $('.megamenu.homeonly li.menu-item.level_1 > a').removeClass('alternative');
        $('.megamenu.homeonly a.nav__icons.user').removeClass("alternative");
        $('.megamenu.homeonly a.nav__icons.cart').removeClass("alternative");
        $('.megamenu.homeonly a.wishlist').removeClass("alternative");

        $('.megamenu.homeonly #searchicndw').removeClass('d-none');
        $('.megamenu.homeonly #searchicndw').show();
        $('.megamenu.homeonly #searchicnd').addClass('d-none');
        $('.megamenu.homeonly #searchicndwd').removeClass('d-none');
        $('.megamenu.homeonly #searchicndd').addClass('d-none');
        $('.megamenu.homeonly #burgericnbw').removeClass('d-none');
        $('.megamenu.homeonly #burgericn').addClass('d-none');
        $('.megamenu.homeonly #cart-has-items').addClass('alternative');
        $(".megamenu.homeonly").css("background", "transparent");

      }
    }
          
    }

  );



  $('#searchBar').hover(

    function () {
      $('nav.megamenu.homeonly').addClass('scrolled');
      $('nav.megamenu.homeonly').removeClass('notscrolled');
      $('nav.megamenu.homeonly').mouseover();
    },

    function () {
      $('nav.megamenu.homeonly').removeClass('scrolled');
      $('nav.megamenu.homeonly').addClass('notscrolled');
    }

  );

  $('.boost-pfs-search-suggestion-wrapper').hover(

    function () {
      $('nav.megamenu.homeonly').addClass('scrolled');
      $('nav.megamenu.homeonly').removeClass('notscrolled');
      $('nav.megamenu.homeonly').mouseover();
    },

    function () {

    }
  );





  $('.mobile__menu__item').each(function () {

    if ($(this).children("ul.sub-menu").length) {
      // the clicked on 
      $(this).find("a.mobile__menu__link").addClass("nested");
    }

    if ($(this).find("ul.sub-menu")) {

      //$(this).find("ul.sub-menu li a").addClass("nested");


    } else {
   //   console.log(this + "not");
    }

  });


  $(".mobile-burger").click(function () {

    if (document.documentElement.clientWidth < 1024) {
      // $("html").scrollTop(0);
      $('.megamenu').addClass('was-open');
    }


    if ($("#searchBar").css("display") == "block") {
      // Element has display: flex
      $("#search_button_mobile").trigger('click');


    } else {
      // Element has a different display value
    }


    if ($(".megamenu").hasClass("homeonly")) {


      if ($(document).scrollTop() < 30) {



        if ($('#burgercrossicn').css('display') == 'none') {

          $("#burgercrossicn").toggle();
          $('.megamenu.notscrolled.wasscrolled').removeClass("wasscrolled");
          $('.megamenu.homeonly #burgericnbw').addClass('d-none');
          $('.megamenu.homeonly #burgericn').addClass('d-none');
          $('.megamenu.homeonly #burgericn').hide();
          $('.megamenu.homeonly #searchicnd').removeClass('d-none');
          $('.megamenu.homeonly #searchicnd').show();
          $('.megamenu.homeonly #searchicndw').addClass('d-none');
          $('.megamenu.homeonly').css("background", "white");
          $('.megamenu.homeonly #cart-has-items').removeClass('alternative');
          $('.megamenu.homeonly a.nav__icons.cart').addClass("alternative");
          $('.megamenu.homeonly a.logo').addClass('alternative');

        } else {

          $("#burgercrossicn").toggle();

          $('.megamenu.homeonly #burgericn').show();

          //  $('.megamenu.homeonly #burgericn').removeClass('d-none');
          // $('.megamenu.homeonly').css("background", "transparent");
          $('.megamenu.homeonly #burgericn').removeClass('d-none');
          $('.menu.level-1').removeClass('is-current');
          $('.media__heading media__heading__first-level').removeClass('is-current');
          $('.single-item.first__level').removeClass('is-current');
        //  console.log("burger chiuso");
          // $('.megamenu.homeonly #searchicndw').removeClass('d-none');
          // $('.megamenu.homeonly #searchicnd').addClass('d-none');
          // $('.megamenu.homeonly a.logo').removeClass('alternative');
          //  $('.megamenu.homeonly #cart-has-items').addClass('alternative');
          //  $('.megamenu.homeonly a.nav__icons.cart').removeClass("alternative");

        }

      } else {
        //  $(".mobile-burger img").toggle();
        $("#burgericnbw").show();

        if ($('#burgercrossicn').css('display') == 'none') {
          $("#burgercrossicn").toggle();
          $('.megamenu.homeonly #burgericn').addClass('d-none');
          $('.megamenu.homeonly #burgericn').hide();

        } else {
          $("#burgercrossicn").toggle();
          $('.megamenu.homeonly #burgericn').removeClass('d-none');
          $('.megamenu.homeonly #burgericn').show();
        }

      }


    } else {

      $(".mobile-burger img").toggle();

    }

  });




  $(".mobile-magnifying-glass").click(function () {

    // $(".mobile-magnifying-glass img").toggle();
    // $("#searchBar").toggle();

  });


  $(".desktop-magnifying-glass").click(function () {

    if (document.documentElement.clientWidth < 1024) {
      // $("html").scrollTop(0);
      $('.megamenu').addClass('was-open');
    }

    if ($(".megamenu").hasClass("homeonly")) {

      $('.megamenu #searchicndd').toggle();
      $('.megamenu #searchicnd').toggle();
      $('.megamenu #crossicnd').toggle();
      $("#searchBar").toggle();

      $('#searchicnd').addClass('d-none');
      $('#searchicnd').hide();

      if ($("#searchBar").css("display") == "block") {
        //     $("body").css("overflow", "none!important");
      }

    } else {
      $('.megamenu #searchicndd').toggle();
      $('.megamenu #searchicnd').toggle();
      $('.megamenu #crossicnd').toggle();
      $("#searchBar").toggle();


    }


    if ($("#searchBar").css("display") == "block") {

      if ($(document).scrollTop() > 30) {



        $('.megamenu.homeonly #searchicndw').addClass('d-none');
        $('.megamenu.homeonly #searchicndw').hide();
        $('.megamenu.homeonly #searchicnd').addClass('d-none');
        $('.megamenu.homeonly #searchicnd').hide();

        $('.megamenu.homeonly #burgericnbw').addClass('d-none');

        $('.megamenu.homeonly #burgericn').removeClass('d-none');
       // $('.megamenu.homeonly #cart-has-items').remove('alternative');
        // $('.megamenu.homeonly a.logo').removeClass('alternative');

      } else {

        $('.megamenu.homeonly a.logo').addClass('alternative');
        $('.megamenu.homeonly #cart-has-items').removeClass('alternative');
        $('.megamenu.homeonly a.nav__icons.cart').addClass("alternative");
       

        if ($("#searchBar").css("display") == "block") {
          $('.megamenu.homeonly #searchicnd').addClass('d-none');
          $('.megamenu.homeonly #searchicnd').hide();
        }

      }

      $(".megamenu.homeonly").addClass("search__open");
      //$("#boost-pfs-search-suggestion-mobile").removeClass("hidden");
      $('.megamenu.homeonly #searchicndw').addClass('d-none');

      // $('.megamenu.homeonly #searchicnd').addClass('d-none');
      $('.megamenu.homeonly #burgericn').removeClass('d-none');
      $('.megamenu.homeonly #burgericnbw').addClass('d-none');
     // console.log("menu aperto");
      $('.megamenu.notscrolled.wasscrolled').removeClass("wasscrolled");


    } else {


      // scroll to top else not 1024 non e' aperta la ricerca

      $(".megamenu.homeonly").removeClass("search__open");
      // $("#boost-pfs-search-suggestion-mobile").addClass("hidden");
      // $("#boost-pfs-search-suggestion-mobile").hide();


      if ($(document).scrollTop() < 30) {

        if (document.documentElement.clientWidth < 1024) {

          // $('.megamenu.homeonly a.logo').removeClass('alternative');
          //  $('.megamenu.homeonly a.nav__icons.user').removeClass("alternative");
          //  $('.megamenu.homeonly a.nav__icons.cart').removeClass("alternative");
          //     $('.megamenu.homeonly #searchicndw').removeClass('d-none');
          //   $('.megamenu.homeonly #searchicndw').show();
          $('.megamenu.homeonly #searchicnd').removeClass('d-none');
          $('.megamenu.homeonly #searchicnd').show();
          //  $('.megamenu.homeonly #searchicndwd').removeClass('d-none');
          //$('.megamenu.homeonly #searchicndd').addClass('d-none');
          $('.megamenu.homeonly #burgericnbw').addClass('d-none');
          // $('.megamenu.homeonly #burgericn').removeClass('d-none');
          // $('.megamenu.homeonly #cart-has-items').removeClass('alternative');
          $('.megamenu.homeonly').removeClass('scrolled');
          $('.megamenu.homeonly').removeClass('wasscrolled');
          // $('.megamenu.homeonly').css('background-color', 'transparent');
          $('.megamenu.homeonly').addClass('has_scrolled_closed_search');
          $('.megamenu.homeonly').css('background-color', 'white!important');

        }


      //  console.log("chiuso sotto i 30");

      } else {


        $('.megamenu.homeonly #searchicndw').addClass('d-none');
        $('.megamenu.homeonly #searchicnd').removeClass('d-none');
        $('.megamenu.homeonly #searchicnd').show();
        // $('.megamenu.homeonly #searchicndwd').addClass('d-none');
        // $('.megamenu.homeonly #searchicndd').removeClass('d-none');

      }



    }

  });






  $("#search_button_mobile").click(function () {

    if ($(".menu-wrapper").hasClass("is-visible")) {

      $(".menu-wrapper").removeClass("is-visible");
      $(".mobile-burger").click();

    }

  });



  $('.new-hero-section').on({
    'touchstart': function () {

      if ($(document).scrollTop() < 30) {

        if ($(".megamenu").css("background-color") == "transparent") {

        }
      }
    }
  });

}(jQuery));